import React from 'react';
import { styled } from '@glitz/react';
import { Pause24x24 } from 'Shared/Icons/Pause';
import { Play24x24 } from 'Shared/Icons/Play';

const Play = styled(Play24x24, {
  cursor: 'pointer'
})

const Pause = styled(Pause24x24, {
  cursor: 'pointer'
})

type PropType = {
  isPlaying: boolean;
  play: () => void;
  pause: () => void;
};

const PlayControls = ({ isPlaying, play, pause }: PropType) => {
  return isPlaying ? (
    <Pause onClick={pause} />
  ) : (
    <Play onClick={play} />
  );
};

export default PlayControls;
